
import BagTimer from "../../../assets/filled/BagTimer.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function BagTimerIcon({ className, dataTestid = "BagTimerIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <BagTimer data-testid={dataTestid} className={classes} {...rest} />
  );
}
